/**
 * 로그 · 에러 수집에 나가기 전 개인정보 · 비밀을 가린다.
 * X5(observability.md)가 생기면 그 마스킹 규칙으로 맞춘다.
 */
export const MASKED = '[masked]';

const SENSITIVE_KEY =
  /pass(word)?|token|secret|authorization|cookie|session|email|phone|mobile|birth|ssn|rrn|account|card/i;
const EMAIL = /[\w.+-]+@[\w-]+(\.[\w-]+)+/g;
const BEARER = /Bearer\s+[\w.~+/-]+=*/gi;
const MAX_DEPTH = 5;

export function maskText(text: string): string {
  return text.replace(BEARER, `Bearer ${MASKED}`).replace(EMAIL, MASKED);
}

export function maskSensitive(value: unknown, depth = 0): unknown {
  if (typeof value === 'string') return maskText(value);
  if (value === null || typeof value !== 'object') return value;
  if (depth >= MAX_DEPTH) return '[truncated]';
  if (value instanceof Error) {
    return { name: value.name, message: maskText(value.message) };
  }
  if (Array.isArray(value)) return value.map((item) => maskSensitive(item, depth + 1));

  const masked: Record<string, unknown> = {};
  for (const [key, item] of Object.entries(value)) {
    masked[key] = SENSITIVE_KEY.test(key) ? MASKED : maskSensitive(item, depth + 1);
  }
  return masked;
}
